function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.6087 8.99997H1.34364C1.15385 8.99997 1 9.15382 1 9.34361V10.8V13.2V14.6563C1 14.8461 1.15385 15 1.34364 15H3.6087M20.3913 8.99997H22.6564C22.8461 8.99997 23 9.15382 23 9.34361V10.5V13.5V14.6563C23 14.8461 22.8461 15 22.6564 15H20.3913",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 1.99997,
  width: 7,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 1.99997,
  width: 7,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 5.99997,
  width: 12,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 5.99997,
  width: 2,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 11,
  width: 16,
  height: 2,
  rx: 0.171821,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 17,
  width: 16,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 21,
  width: 3,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 21,
  width: 11,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var SvgLogsIssues = function SvgLogsIssues(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogsIssues, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logs-issues.93547fe1.svg";
export { ForwardRef as ReactComponent };